// extracted by mini-css-extract-plugin
export default {"sponsoredOffersHeading":"redeemPage_sponsoredOffersHeading__Yw5A8","info":"redeemPage_info__cYkkv"};